import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  type OnInit,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MENTION_TRIGGER } from '@principle-theorem/editor';
import { type IContextualAction } from '@principle-theorem/ng-principle-shared';
import { TrackByFunctions } from '@principle-theorem/ng-shared';
import {
  type IInteractiveResource,
  type IPrincipleMention,
} from '@principle-theorem/principle-core/interfaces';
import { MentionActionResolverService } from '../mention-action-resolver.service';

@Component({
  selector: 'pr-mention-resource',
  templateUrl: './mention-resource.component.html',
  styleUrls: ['./mention-resource.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatMenu, MatMenuTrigger, MatMenuItem, MatIcon],
})
export class MentionResourceComponent implements OnInit {
  trackByAction = TrackByFunctions.field<IContextualAction>('name');
  @Input() resource: IPrincipleMention;
  @Input() interactiveResource: IInteractiveResource;
  actions: IContextualAction[] = [];
  mentionTrigger: string = MENTION_TRIGGER;

  constructor(private _mentionActionResolver: MentionActionResolverService) {}

  ngOnInit(): void {
    this._resolveMentionActions();
  }

  runAction(action: IContextualAction): void {
    action.do(this.resource.resource, this.interactiveResource);
  }

  /**
   * Injects the services for a mention's required actions
   *
   * @private
   * @memberof MentionResourceComponent
   */
  private _resolveMentionActions(): void {
    this.actions = this._mentionActionResolver.resolveActions(
      this.resource.resource.type
    );
  }
}
